import { useAdvanceSearchContext } from "../AdvanceSearchContext";

export default function GitHub() {
  const { searchObject, onChange, t } = useAdvanceSearchContext();
  
  return (
    <fieldset>
      <legend>{t("GitHub")}</legend>
      <input
        onChange={onChange}
        value={searchObject.gitHub || ""}
        name="gitHub"
        className="form-control"
      />{" "}
    </fieldset>
  );
}
